import React, { useCallback, useRef } from 'react';

import isEqual from 'lodash/isEqual';

import { partialMatchKey } from './utils';

export const SilentContext = React.createContext({});

export const SilentProvider = ({ children }) => {
  const silentQueries = useRef([]);

  const addQuery = useCallback((queryKey) => {
    silentQueries.current = [...silentQueries.current, queryKey];
  }, []);

  const resetQuery = useCallback((queryKey) => {
    silentQueries.current = silentQueries.current.filter(
      (el) => !isEqual(el, queryKey)
    );
  }, []);

  const isSilentQuery = useCallback(
    (queryKey) => {
      return silentQueries.current.reduce((result, current) => {
        return result || partialMatchKey(queryKey, current);
      }, false);
    },
    [silentQueries]
  );

  return (
    <SilentContext.Provider value={{ addQuery, resetQuery, isSilentQuery }}>
      {children}
    </SilentContext.Provider>
  );
};
